
interface Date {
    setTimeZone?: (val: any) => Date;
    getISOString?: () => String;
    addDays?: (val) => Date;
    addMonths?: (val) => Date;
    isLessThan?: (val: Date) => boolean;
    isLessThanOrEqual?: (val: Date) => boolean;
    getDateFromString?: (val: string) => any;
}

Date.prototype.setTimeZone = function(e) {
    return new Date(new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate(),
            this.getHours(), this.getMinutes(), this.getSeconds())).toLocaleString("en-US", {timeZone: e.Name})); 
}

Date.prototype.getISOString = function() {
    var i= 0, A = [this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(),
        this.getMinutes(), this.getSeconds()], T;
    A[1]+= 1;
    while(i++<7){
        T= A[i];
        if(T<10) A[i]= '0'+T;
    }
    return A.splice(0, 3).join('-')+'T'+A.join(':');    
}

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

Date.prototype.addMonths = function(val) {
    var date = new Date(this.valueOf());
    date.setMonth(date.getMonth() + val);
    return date;
}

Date.prototype.isLessThan = function(val) {
    if (this.valueOf() < val) return true;
    return false;
}

Date.prototype.isLessThanOrEqual = function(val) {
    if (this.valueOf() <= val) return true;
    return false;
}

Date.prototype.getDateFromString = function(val) {
    if (val != "" && val != null) return new Date(val);
    return val;
}